import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorUI } from '../components/UI/Modals/Modals';
import { PostMethod } from '../services/CallApi';
import { CheckValue, sortData } from '../services/CommonFunction';
import { staticVar } from '../services/Constants';
import { setCoach } from '../services/SetApiResponse';
import { userData } from '../services/subscriberService';

const initialState = {
    list: [],
    status: staticVar.idle
};

export const getCategoryIconList =  createAsyncThunk('_getCoach', async (data,{ dispatch, rejectWithValue }) => {
    try {
        const data = {
            gym_id: userData.selectedGym.gym_id,
            only_approved: true
        }
        const response = await PostMethod('_getCoach',data);
        return response.data.data.map(el => (setCoach(el))).sort(sortData);
    } catch (err) {
        if (!err.response) {
            throw err
        }
        if(err.response.data.statusCode === 401) {
            ErrorUI(err.response.data);
        }

        return rejectWithValue({err: err.response.data,id: data.id,updated: data.updated})
    }
});

const categoryIconSlice = createSlice({
    name: 'categoryIcon',
    initialState,
    reducers: {
        resetCategoryIcon: (state) => {
            state.list = []; 
            state.status = staticVar.idle;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCategoryIconList.pending, (state,action) => {
                state.status = staticVar.loading;
            })
            .addCase(getCategoryIconList.fulfilled, (state,action) => {
                const list = [...state.list];
                if(CheckValue(list)) {
                    action.payload.forEach(element => {
                        list.push(element);
                    });
                    state.list = list;
                }
                state.status = staticVar.idle;
            })
            .addCase(getCategoryIconList.rejected, (state,action) => {
                console.error('rejected');
                state.status = staticVar.idle;
                // ErrorUI(action.payload.err);
            })
    }
});

export const getAllCategoryIcon = (state) => state.categoryIcon;
export const { resetCategoryIcon } = categoryIconSlice.actions;
export default categoryIconSlice.reducer;